var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-box-cmp"},[_c('div',{class:{
      'loader-div':
        Object.keys(_vm.reportLeft).length === 0 ||
        Object.keys(_vm.reportRight).length === 0 ||
        Object.keys(_vm.reportCmp).length === 0,
      'd-none-for-loader':
        Object.keys(_vm.reportLeft).length > 0 ||
        Object.keys(_vm.reportRight).length > 0 ||
        Object.keys(_vm.reportCmp).length > 0
    }},[_vm._m(0)]),(Object.keys(_vm.reportLeft).length > 0)?_c('div',{staticClass:"radio-time-frames",class:{
      'disabled-avg': _vm.avgMode === false
    },on:{"click":function($event){return _vm.getAvgStats()}}},[_c('span',{staticClass:"filter-buttons radio-frames date-groups"},[_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"time-filters","id":"7","value":"7","checked":""},on:{"click":function($event){return _vm.changeAvgFilter($event)}}}),_c('label',{staticClass:"filter-title for-date-groups",attrs:{"for":"7"}},[_vm._v("7")])]),_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"time-filters","id":"30","value":"30"},on:{"click":function($event){return _vm.changeAvgFilter($event)}}}),_c('label',{staticClass:"filter-title for-date-groups",attrs:{"for":"30"}},[_vm._v("30")])]),_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"time-filters","id":"90","value":"90"},on:{"click":function($event){return _vm.changeAvgFilter($event)}}}),_c('label',{staticClass:"filter-title for-date-groups",attrs:{"for":"90"}},[_vm._v("90")])]),_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"time-filters","id":"180","value":"180"},on:{"click":function($event){return _vm.changeAvgFilter($event)}}}),_c('label',{staticClass:"filter-title for-date-groups",attrs:{"for":"180"}},[_vm._v("180")])])])]):_vm._e(),_c('div',{staticClass:"stats-compare-calendars"},[(Object.keys(_vm.reportLeft).length > 0)?_c('div',{staticClass:"report-options"},[_c('span',{staticClass:"filter-buttons groups"},[_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"filters","id":"reg","value":"REG","checked":""},on:{"click":function($event){return _vm.changeFilter($event)}}}),_c('label',{staticClass:"filter-title for-groups",attrs:{"for":"reg"}},[_vm._v("REG")])]),_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"filters","id":"dup","value":"DUP"},on:{"click":function($event){return _vm.changeFilter($event)}}}),_c('label',{staticClass:"filter-title for-groups",attrs:{"for":"dup"}},[_vm._v("DUP")])]),_c('div',[_c('input',{staticClass:"filter",attrs:{"type":"radio","name":"filters","id":"all","value":"ALL"},on:{"click":function($event){return _vm.changeFilter($event)}}}),_c('label',{staticClass:"filter-title for-groups",attrs:{"for":"all"}},[_vm._v("ALL")])])]),_c('div',{staticClass:"report-calendar permanent-a",class:{
          'disabled-avg': _vm.avgMode === true
        }},[_c('date-picker',{attrs:{"lang":"en","inline":"","disabled-date":_vm.notAfterToday,"get-classes":_vm.getClasses},on:{"input":_vm.getReportByDate},model:{value:(_vm.reportDate),callback:function ($$v) {_vm.reportDate=$$v},expression:"reportDate"}})],1)]):_vm._e(),(
        Object.keys(_vm.reportLeft).length > 0 &&
          Object.keys(_vm.reportRight).length > 0
      )?_c('table',{staticClass:"data-compare-table",attrs:{"id":"comp-table"}},[_c('tr',[_c('th',{staticClass:"table-header"},[(_vm.avgMode)?_c('span',[_vm._v(_vm._s(_vm.avgFilterOption)+" days")]):_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.reportDate)))])]),_c('th',{staticClass:"table-header"},[_c('button',{staticClass:"btn btn-default btn-sm override",on:{"click":function($event){return _vm.applySorting(1, 1)}}},[_c('span',{staticClass:"fa",class:{
                'fas fa-sort-numeric-down': _vm.sortOrder[0] === 'asc',
                'fas fa-sort-numeric-up': _vm.sortOrder[0] === 'desc'
              }})])]),_c('th'),_c('th'),_c('th',{staticClass:"table-header"},[_vm._v(_vm._s(_vm.formatDate(_vm.reportCmpDate)))]),_c('th',{staticClass:"table-header"},[_c('button',{staticClass:"btn btn-default btn-sm override",on:{"click":function($event){return _vm.applySorting(1, 5)}}},[_c('span',{staticClass:"fa",class:{
                'fas fa-sort-numeric-down': _vm.sortOrder[0] === 'asc',
                'fas fa-sort-numeric-up': _vm.sortOrder[0] === 'desc'
              }})])])]),_vm._l((_vm.statsTabs),function(tab){return (_vm.reportLeft[tab.alias] && _vm.reportRight[tab.alias])?_c('tr',{key:tab.id},[_c('td',[_vm._v(_vm._s(tab.name))]),_c('td',[(
              _vm.reportLeft[tab.alias]['all_data'][_vm.filterOption].length === 0 &&
                Array.isArray(_vm.reportLeft[tab.alias]['all_data'][_vm.filterOption])
            )?_c('span',{staticClass:"stats-tabs-numbers"},[_vm._v(" - ")]):_c('span',{staticClass:"stats-tabs-numbers"},[(
                Array.isArray(_vm.reportLeft[tab.alias]['all_data'][_vm.filterOption])
              )?_c('span',{class:_vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                  .total_in_time_frame -
                  _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame >=
                0
                  ? 'positive-overlap'
                  : 'negative'},[_vm._v(" "+_vm._s(_vm.reportLeft[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame)+" ")]):_c('span',[(tab.alias == 'cc_decline_deposits')?_c('span',{class:_vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                    .total_deposits_in_time_frame -
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_deposits_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative'},[_vm._v(" "+_vm._s(_vm.reportLeft[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame)+" ")]):_c('span',{class:_vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                    .total_in_time_frame -
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative'},[_vm._v(" "+_vm._s(_vm.reportLeft[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame)+" ")])])])]),_c('td',[(
              _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption].length === 0 ||
                _vm.report[tab.alias]['all_data'][_vm.filterOption].length === 0
            )?_c('span',{staticClass:"stats-tabs-numbers"},[(
                _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption].length === 0 &&
                  _vm.report[tab.alias]['all_data'][_vm.filterOption].length === 0
              )?_c('span',[_vm._v("-")]):_c('span',[(
                  _vm.report[tab.alias]['all_data'][_vm.filterOption].length === 0
                )?_c('span',{staticClass:"stats-tabs-numbers negative"},[(
                    Array.isArray(
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                    )
                  )?_c('span',[_vm._v(" -"+_vm._s(_vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame)+" ")]):_c('span',[(tab.alias == 'cc_decline_deposits')?_c('span',[_vm._v(" -"+_vm._s(_vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame)+" ")]):_c('span',[_vm._v(" -"+_vm._s(_vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame)+" ")])])]):_c('span',{staticClass:"stats-tabs-numbers positive-overlap"},[(
                    Array.isArray(_vm.report[tab.alias]['all_data'][_vm.filterOption])
                  )?_c('span',[_vm._v(" +"+_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame)+" ")]):_c('span',[(tab.alias == 'cc_decline_deposits')?_c('span',[_vm._v(" +"+_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame)+" ")]):_c('span',[_vm._v(" +"+_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame)+" ")])])])])]):_c('span',{staticClass:"stats-tabs-numbers"},[(
                Array.isArray(
                  _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                ) &&
                  Array.isArray(_vm.report[tab.alias]['all_data'][_vm.filterOption])
              )?_c('span',{class:[
                _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                  .total_in_time_frame -
                  _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame >=
                0
                  ? 'positive-overlap'
                  : 'negative',
                {
                  'zero-color':
                    _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                        .total_in_time_frame ===
                    0
                }
              ]},[(
                  _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame -
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame >=
                    0
                )?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame)+" ")]):_c('span',[(
                  Array.isArray(
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                  )
                )?_c('span',{class:[
                  _vm.report[tab.alias]['all_data'][_vm.filterOption]
                    .total_in_time_frame -
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative',
                  {
                    'zero-color':
                      _vm.report[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                          .total_in_time_frame ===
                      0
                  }
                ]},[(
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                        .total_in_time_frame >=
                      0
                  )?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame)+" ")]):_vm._e(),(
                  Array.isArray(_vm.report[tab.alias]['all_data'][_vm.filterOption])
                )?_c('span',{class:[
                  _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame -
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative',
                  {
                    'zero-color':
                      _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                        .total_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                          .total_in_time_frame ===
                      0
                  }
                ]},[(
                    _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame >=
                      0
                  )?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame)+" ")]):_c('span',[(tab.alias == 'cc_decline_deposits')?_c('span',{class:[
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_deposits_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                        .total_deposits_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        _vm.report[tab.alias]['all_data'][_vm.filterOption]
                          .total_deposits_in_time_frame -
                          _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                            .total_deposits_in_time_frame ===
                        0
                    }
                  ]},[(
                      _vm.report[tab.alias]['all_data'][_vm.filterOption]
                        .total_deposits_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                          .total_deposits_in_time_frame >=
                        0
                    )?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame)+" ")]):_c('span',{class:[
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        _vm.report[tab.alias]['all_data'][_vm.filterOption]
                          .total_in_time_frame -
                          _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                            .total_in_time_frame ===
                        0
                    }
                  ]},[(
                      _vm.report[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                          .total_in_time_frame >=
                        0
                    )?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame)+" ")])])])])]),_c('td',[(
              _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption].length === 0 ||
                _vm.report[tab.alias]['all_data'][_vm.filterOption].length === 0
            )?_c('span',{staticClass:"stats-tabs-numbers"},[_vm._v("- ")]):_c('span',{staticClass:"stats-tabs-numbers"},[(
                Array.isArray(
                  _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                ) &&
                  Array.isArray(_vm.report[tab.alias]['all_data'][_vm.filterOption])
              )?_c('span',{class:[
                _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                  .total_in_time_frame -
                  _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame >=
                0
                  ? 'positive-overlap'
                  : 'negative',
                {
                  'zero-color':
                    _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                        .total_in_time_frame ===
                    0
                }
              ]},[(
                  _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame -
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame >=
                    0
                )?_c('span'):_vm._e(),_vm._v(_vm._s(( ((_vm.report[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame) / Math.max( 1, _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame )) * 100 ).toFixed(0) + "%")+" ")]):_c('span',[(
                  Array.isArray(
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                  )
                )?_c('span',{class:[
                  _vm.report[tab.alias]['all_data'][_vm.filterOption]
                    .total_in_time_frame -
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative',
                  {
                    'zero-color':
                      _vm.report[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                          .total_in_time_frame ===
                      0
                  }
                ]},[(
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption][0]
                        .total_in_time_frame >=
                      0
                  )?_c('span'):_vm._e(),_vm._v(_vm._s(( ((_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame) / Math.max( 1, _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame )) * 100 ).toFixed(0) + "%")+" ")]):_vm._e(),(
                  Array.isArray(_vm.report[tab.alias]['all_data'][_vm.filterOption])
                )?_c('span',{class:[
                  _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                    .total_in_time_frame -
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative',
                  {
                    'zero-color':
                      _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                        .total_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                          .total_in_time_frame ===
                      0
                  }
                ]},[(
                    _vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame >=
                      0
                  )?_c('span'):_vm._e(),_vm._v(_vm._s(( ((_vm.report[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame) / Math.max( 1, _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame )) * 100 ).toFixed(0) + "%")+" ")]):_c('span',[(tab.alias == 'cc_decline_deposits')?_c('span',{class:[
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_deposits_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                        .total_deposits_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        _vm.report[tab.alias]['all_data'][_vm.filterOption]
                          .total_deposits_in_time_frame -
                          _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                            .total_deposits_in_time_frame ===
                        0
                    }
                  ]},[(
                      _vm.report[tab.alias]['all_data'][_vm.filterOption]
                        .total_deposits_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                          .total_deposits_in_time_frame >=
                        0
                    )?_c('span'):_vm._e(),_vm._v(_vm._s(( ((_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame) / Math.max( 1, _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame )) * 100 ).toFixed(0) + "%")+" ")]):_c('span',{class:[
                    _vm.report[tab.alias]['all_data'][_vm.filterOption]
                      .total_in_time_frame -
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame >=
                    0
                      ? 'positive-overlap'
                      : 'negative',
                    {
                      'zero-color':
                        _vm.report[tab.alias]['all_data'][_vm.filterOption]
                          .total_in_time_frame -
                          _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                            .total_in_time_frame ===
                        0
                    }
                  ]},[(
                      _vm.report[tab.alias]['all_data'][_vm.filterOption]
                        .total_in_time_frame -
                        _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                          .total_in_time_frame >=
                        0
                    )?_c('span'):_vm._e(),_vm._v(_vm._s(( ((_vm.report[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame - _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame) / Math.max( 1, _vm.reportCmp[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame )) * 100 ).toFixed(0) + "%")+" ")])])])])]),_c('td',[_vm._v(_vm._s(tab.name))]),_c('td',[(
              _vm.reportRight[tab.alias]['all_data'][_vm.filterOption].length === 0 &&
                Array.isArray(
                  _vm.reportRight[tab.alias]['all_data'][_vm.filterOption]
                )
            )?_c('span',{staticClass:"stats-tabs-numbers"},[_vm._v(" - ")]):_c('span',{staticClass:"stats-tabs-numbers"},[(
                Array.isArray(
                  _vm.reportRight[tab.alias]['all_data'][_vm.filterOption]
                )
              )?_c('span',{class:_vm.report[tab.alias]['all_data'][_vm.filterOption][0]
                  .total_in_time_frame -
                  _vm.getProperReport(
                    _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                  ).total_in_time_frame >=
                0
                  ? 'positive-overlap'
                  : 'negative'},[_vm._v(" "+_vm._s(_vm.reportRight[tab.alias]["all_data"][_vm.filterOption][0] .total_in_time_frame)+" ")]):_c('span',[(tab.alias == 'cc_decline_deposits')?_c('span',{class:_vm.report[tab.alias]['all_data'][_vm.filterOption]
                    .total_deposits_in_time_frame -
                    _vm.getProperReport(
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                    ).total_deposits_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative'},[_vm._v(" "+_vm._s(_vm.reportRight[tab.alias]["all_data"][_vm.filterOption] .total_deposits_in_time_frame)+" ")]):_c('span',{class:_vm.report[tab.alias]['all_data'][_vm.filterOption]
                    .total_in_time_frame -
                    _vm.getProperReport(
                      _vm.reportCmp[tab.alias]['all_data'][_vm.filterOption]
                    ).total_in_time_frame >=
                  0
                    ? 'positive-overlap'
                    : 'negative'},[_vm._v(" "+_vm._s(_vm.reportRight[tab.alias]["all_data"][_vm.filterOption] .total_in_time_frame)+" ")])])])])]):_vm._e()})],2):_vm._e(),(Object.keys(_vm.reportCmp).length > 0)?_c('div',{staticClass:"report-options calendar-cmp"},[_c('div',{staticClass:"report-calendar permanent-b"},[_c('date-picker',{attrs:{"lang":"en","inline":"","disabled-date":_vm.notAfterTomorrow,"get-classes":_vm.getCmpClasses},on:{"input":_vm.getCmpReportByDate},model:{value:(_vm.reportCmpDate),callback:function ($$v) {_vm.reportCmpDate=$$v},expression:"reportCmpDate"}})],1),(_vm.factoryReportDate !== null)?_c('div',{staticClass:"factory-report-date"},[_vm._v(" "+_vm._s(_vm.factoryReportDate)+" ")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"insteadLoader"},[_vm._v("GENERATING REPORT ,PLEASE WAIT "),_c('div',{staticClass:"snippet",attrs:{"data-title":".dot-flashing"}},[_c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-flashing"})])])])}]

export { render, staticRenderFns }